export enum Tab {
  BET_SLIP = 'betSlip',
  MY_STAKES = 'myStakes',
}
